

export const EVENT_PREFIX = 'er24-gfonts-scan-';
export const EVENT_RESET = EVENT_PREFIX + 'reset';
export const EVENT_FORM_SUBMITTED = EVENT_PREFIX + 'form-submitted';
export const EVENT_RESULT_AVAILABLE = EVENT_PREFIX + 'result-available';
export const EVENT_DETAILS_BUTTON_CLICKED = EVENT_PREFIX + 'details-button-clicked';
export const EVENT_LEAD_FORM_SUBMITTED = EVENT_PREFIX + 'lead-form-submitted';
export const EVENT_LEAD_CONFIRMED = EVENT_PREFIX + 'lead-confirmed';
export const EVENT_LEAD_MODAL_CLOSED = EVENT_PREFIX + 'lead-modal-closed';
export const EVENT_ERROR = EVENT_PREFIX + 'error';
